// ページツリー (サイドバー) のノード単位 折りたたみコントローラ
//
// 現在ページの祖先パスはサーバー側で展開描画されるため、初期表示はそれだけで
// 完結する (JS による状態復元なし = ページ遷移時にチラつかない)。このコントローラは
// chevron クリックでの開閉だけを担う。子は <turbo-frame> で、初回展開時に
// data-src を src へ昇格させて遅延ロードする (一度開いた枝は hidden トグルのみ)。
//
// 展開状態はページ遷移をまたいで保持しない (遷移すると新しい現在パスのみ展開)。
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // ページを開いたとき、現在ページのノードがサイドバーの表示領域に入るよう
    // スクロールする (深いツリーで現在地が画面外に隠れるのを防ぐ)。
    // レイアウト確定前 (コンテナ高さ 0) は少し待ってから実行する。
    this._revealTries = 0
    this._scheduleReveal()
  }

  disconnect() {
    clearTimeout(this._revealTimer)
  }

  _scheduleReveal() {
    const container = this.element.closest("aside")
    // レイアウト未確定なら 16ms 間隔で再試行 (背景タブでも発火する setTimeout を使う)
    if (container && container.clientHeight === 0 && this._revealTries < 30) {
      this._revealTries++
      this._revealTimer = setTimeout(() => this._scheduleReveal(), 16)
      return
    }
    this._revealActive(container)
  }

  // 現在ページ (.bg-akebono-active) が表示領域外なら、サイドバーの
  // スクロールコンテナ内で中央付近に来るようスクロールする。
  _revealActive(container) {
    const active = this.element.querySelector(".bg-akebono-active")
    if (!active) return
    if (!container) return active.scrollIntoView({ block: "center" })

    const c = container.getBoundingClientRect()
    const a = active.getBoundingClientRect()
    if (a.top >= c.top && a.bottom <= c.bottom) return // 既に見えている
    container.scrollTop += a.top - c.top - (c.height - a.height) / 2
  }

  toggle(event) {
    event.preventDefault()
    const btn = event.currentTarget
    const frame = this.element.querySelector(`#sb-children-${btn.dataset.node}`)
    if (!frame) return

    const expand = frame.classList.contains("hidden")
    // 初回展開時のみ遅延ロード (未ロード= src 未設定かつ中身が空)
    if (expand && !frame.getAttribute("src") && frame.dataset.src && frame.childElementCount === 0) {
      frame.setAttribute("src", frame.dataset.src)
    }
    frame.classList.toggle("hidden", !expand)

    btn.setAttribute("aria-expanded", expand ? "true" : "false")
    const svg = btn.querySelector("svg")
    if (svg) svg.classList.toggle("rotate-90", expand)
  }
}
